import Swal from "sweetalert2";
import TableAHSF from "../../Components/TableAHSF"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetReportStageByID } from "../../Redux/Reducers/ReportStage/Stages";
import { useEffect, useState } from "react";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import PopupAHSF from "../../Components/PopupAHSF";
import AddInformationDirectCost from "./AddInformationDirectCost";
import { DeleteExchangeDirectCost } from "../../Redux/Reducers/ReportStage/ExchangeDirectCost";
import { GetOneImplementationStagesAndActivities } from "../../Redux/Reducers/ReportStage/PR_DirectCosts";
import BudgetDirectCostsAddEdit from "../../Pages/BudgetAndTimeFrame/BudgetDirectCosts/BudgetDirectCostsAddEdit";

const InformationDirectCost = (props) => {
    const dispatch = useDispatch();

    const [PopupComponentEditStatus, setPopupComponentEditStatus] = useState(false);
    const stageGuid = useParams().stageGuid
    const refreshLoding = useSelector((state) => state.ExchangeInformationItemAdministrativeCostsReducer.DeleteExchangeInformation)
    const [ExchangeInformationItemInformationDirectCostGUID, setExchangeInformationItemInformationDirectCostGUID] = useState(null)
    const BIEstimatedBudgetForPR_DirectCostsId = useSelector((state) => state.ImplementationStagesAndActivitiesReducers.ImplementationStagesAndActivities)
    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const reportStage = useSelector((state) => state.Stages.ReportsStagesById)
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];

    const RequestAccessor = [
        {
            KeyName: "invoiceNumber",
            ShowStatus: true,
            NmaeColumn: " رقم الفاتورة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "invoiceDetails",
            ShowStatus: true,
            NmaeColumn: " تفاصيل الفاتورة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "shomanContribution",
            ShowStatus: true,
            NmaeColumn: "معلومات صرف مساهمة شومان",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "beneficiaryContribution",
            ShowStatus: true,
            NmaeColumn: "معلومات صرف مساهمة المستفيد",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "invoiceAttachmentFile",
            ShowStatus: true,
            NmaeColumn: "مرفق الفاتورة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false,
            typeColumn: "file",


        },

    ];

    const OtherMainBtns = [


        {
            Click: async (e) => {
                setExchangeInformationItemInformationDirectCostGUID(e.target.value)
                closePopupEditComponent()
            },
            content: "",
            className: "bi bi-pencil-square",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        },
        {
            Click: async (e) => {
                Swal.fire({
                    title: state.jsonData.deleteTitlePopUp?.nameAR,
                    icon: "error",
                    // iconHtml: "؟",
                    confirmButtonText: "تأكيد",
                    cancelButtonText: "الغاء",
                    showCancelButton: true,
                    showCloseButton: true,
                }).then((res) => {
                    if (res.isConfirmed == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم الحذف بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                            // width: "500px",
                        });

                        dispatch(DeleteExchangeDirectCost({ pR_PR_DirectCostsId: e.target.value }))

                    }
                });
            },
            content: "",
            className: "bi bi-trash",
            id: "deleteBtn",
            title: "حذف",
            ShowStatus: true,
        }
    ];




    useEffect(() => {
        dispatch(GetReportStageByID(decryptToken(stageGuid)))
    }, [])
    console.log(reportStage?.pR_Reports?.aI_ApplicationInformationId, "esdvsadsdasddsvdv");

    const PopupOPjectData = {
        isPopupOpenStatus: true,
        idButton:"AddInformationDirectCost",
        isPopupOpenFunction: (e) => {
            console.log(e.target.value, "sdsdsdsdsdsdsdffgg");

            // setPR_EstimatedBudgetForAdministrativeCostsId(e.target.value) 
        },
        componentBody:
            // <></>
            <AddInformationDirectCost action={false} ExchangeInformationItemInformationDirectCostGUID={ExchangeInformationItemInformationDirectCostGUID} stageGuid={props.stageGuid} PR_DirectCostsId={props.PR_DirectCostsId} />
            ,
        maxWidth: "500px",
        maxHeight: "800px",
        title: "الأهداف",
    };
    useEffect(() => {
        dispatch(setRefreshTable());
    }, [refreshLoding])
    const closePopupEditComponent = () => {
        if (PopupComponentEditStatus) {
            setPopupComponentEditStatus(false);
        } else {
            setPopupComponentEditStatus(true);
        }
    };

    useEffect(() => {
        console.log(props.PR_DirectCostsId,"jkhjshdjhsjjh");
        
        if (props.PR_DirectCostsId != undefined) {
            dispatch(GetOneImplementationStagesAndActivities({ pR_PR_DirectCostsId: props.PR_DirectCostsId }))

        }
    }, [props.PR_DirectCostsId])


    console.log(BIEstimatedBudgetForPR_DirectCostsId?.bI_DirectCosts?.itemName        , "Sdsdsdwssdfsdfsewdwdddd");

    return (
        <>
            {
                BIEstimatedBudgetForPR_DirectCostsId?.bI_DirectCostsGuid ?

                    <>
                        <BudgetDirectCostsAddEdit
                            bI_AB_EstimatedBudgetForAdministrativeCostsId={BIEstimatedBudgetForPR_DirectCostsId?.bI_DirectCostsGuid}
                            aI_ApplicationInformation={reportStage?.pR_Reports?.aI_ApplicationInformationId} PlaceOfCall={"InformationDirectCost"} />
                    </>

                    : <></>
            }
            {
                stageGuid ? <TableAHSF
                    culomEdite={culomEdite}
                    uniqueValue={"pR_ExchangeInformationItemImplementationStagesGUID"}
                    valueButtonAction={"pR_ExchangeInformationItemImplementationStagesGUID"}
                    URL={`api/ExchangDirectCost/GetAllPR_ExchangeInformationItemImplementationStagesByPR_ReportsStagesGuid`}
                    UrlBody={{

                        pR_ReportsStagesGuid: props.stageGuid,
                        pR_ImplementationStagesAndActivitiesId: props.PR_DirectCostsId
                    }}
                    staticKeyEdite={staticKeyEdite}
                    accessor={RequestAccessor}
                    titelTable={"معلومات الصرف للتكاليف الإدارية"}
                    selectRowNumber={true}
                    checkBoksColumName="اختيار"
                    sort={true}
                    pagination={true}
                    AppStatus={true}
                    tableBtn={true}
                    sortTable={true}
                    keyNameSort={"dateCreate"}
                    dateKey="dateCreate"
                    dateformat="DD/MM/YYYY h:mm a"
                    arrayNameSort={["applicationNumber"]}
                    search={true}
                    openPopupState={false}
                    DropdownArrayFiltration={[]}
                    DropdownFiltration={false}
                    exportData={true}
                    checkBoks={false}
                    nameColumAction=""
                    total={false}
                    arrayButton={OtherMainBtns}
                    ArrayNameDataColum={RequestsColumns}
                    columnKeyNameArray={[
                        { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                    ]}
                    PopupOPjectData={PopupOPjectData}
                    popUpTitle={"معلومات الطلب"}
                
                /> : <></>
            }
            <PopupAHSF
                title={"الأهداف"}
                idButton="AddInformationDirectCost"
                componentBody={
                    // <></>
                    <AddInformationDirectCost action={true} ExchangeInformationItemInformationDirectCostGUID={ExchangeInformationItemInformationDirectCostGUID} stageGuid={props.stageGuid} PR_DirectCostsId={props.PR_DirectCostsId} />
                }
                maxWidth="500px"
                maxHeight="800px"
                isPopupOpenStatus={PopupComponentEditStatus}
                isPopupOpenFunction={closePopupEditComponent}
            />

        </>
    )
}

export default InformationDirectCost